// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"6f5f7f12","498":"2136139d","703":"ef585201"}[chunkId] + ".chunk.js";
};